import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { style: {"padding":"20px"} }
const _hoisted_2 = {
  key: 0,
  class: "content_container"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "服务未连接", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("立即连接")
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "微信未启动", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("立即启动")
const _hoisted_8 = { class: "content_container" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "微信已启动", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("重启微信")
const _hoisted_11 = {
  key: 0,
  class: "content_container"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "微信未登录", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("立即登录")
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("canvas", {
  id: "qrcode_canvas",
  style: {"display":"block"}
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("刷新二维码")
const _hoisted_17 = {
  key: 1,
  class: "content_container"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "微信已登录", -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode("刷新状态")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_unicon = _resolveComponent("unicon")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.botStatus.serverConnected)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_unicon, {
            name: "info-circle",
            width: "150",
            height: "150",
            fill: "limegreen"
          }),
          _hoisted_3,
          _createVNode(_component_el_button, {
            onClick: _ctx.connect,
            round: "",
            type: "primary",
            style: {"width":"100px"}
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (!_ctx.botStatus.wechatProcessStarted)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_unicon, {
                  name: "info-circle",
                  width: "150",
                  height: "150",
                  fill: "limegreen"
                }),
                _hoisted_6,
                _createVNode(_component_el_button, {
                  onClick: _ctx.startWechatProcess,
                  round: "",
                  type: "primary",
                  style: {"width":"100px"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_unicon, {
                    name: "check-circle",
                    width: "150",
                    height: "150",
                    fill: "limegreen"
                  }),
                  _hoisted_9,
                  _createVNode(_component_el_button, {
                    onClick: _ctx.restartWechatProcess,
                    round: "",
                    type: "primary",
                    style: {"width":"100px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                (!_ctx.botStatus.wechatLoggedin)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (!_ctx.isLoggingIn)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createVNode(_component_unicon, {
                              name: "info-circle",
                              width: "150",
                              height: "150",
                              fill: "limegreen"
                            }),
                            _hoisted_12,
                            _createVNode(_component_el_button, {
                              onClick: _ctx.login,
                              round: "",
                              type: "primary",
                              style: {"width":"100px"}
                            }, {
                              default: _withCtx(() => [
                                _hoisted_13
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _hoisted_15,
                            _createVNode(_component_el_button, {
                              onClick: _ctx.getLoginQrcode,
                              round: "",
                              type: "primary",
                              style: {"width":"100px"}
                            }, {
                              default: _withCtx(() => [
                                _hoisted_16
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]))
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createVNode(_component_unicon, {
                        name: "check-circle",
                        width: "150",
                        height: "150",
                        fill: "limegreen"
                      }),
                      _hoisted_18
                    ]))
              ], 64))
        ], 64)),
    _createVNode(_component_el_button, {
      onClick: _ctx.getStatus,
      round: "",
      type: "primary",
      style: {"width":"100px","margin-top":"20px"}
    }, {
      default: _withCtx(() => [
        _hoisted_19
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}